import React, { useState } from "react";

import CommonInput from "../../../../components/commonFields";
import CustomLabel from "../../../../components/customLabel";
import CustomButton from "../../../../components/customButton";
import { FileIcon } from "../../../../assets/svg";
import { convertBytes } from "../../../../helper/helpers";

import "./styles.scss";

const SaveFile = (props) => {
  const {
    showConfirmPopup,
    getCustomeFileName,
    file,
    responseError,
    resetFileNameErr,
  } = props;

  const [state, setState] = useState({
    customFileName: "",
  });

  const handleOnChange = (e) => {
    const name = e.target.value;
    setState((st) => ({
      ...st,
      customFileName: name,
      error: "",
    }));
    resetFileNameErr();
  };

  const setCustomeFileName = () => {
    getCustomeFileName(state.customFileName);
  };

  return (
    <div className="fields-wrapper">
      <section className="form-row">
        <CustomLabel title="Custom File Title" customClass="label-file" />
        <CommonInput
          className={`custom-form-input mobile-input ${
            responseError !== "" ? "error-field" : ""
          }`}
          placeholder="Custom file  name"
          name="customFileName"
          onChange={handleOnChange}
        />
        <div className="error-label">{responseError}</div>
      </section>

      <section className="form-actions">
        <section className="form-buttons">
          <CustomButton
            className="mr-16 cancel-button file-info"
            btntype="clear"
            title={
              <div className="title">
                <span className="icon">{<FileIcon />}</span>
                <div className="file-details">
                  <span className="file-name" title={file.name}>
                    {file.name}
                  </span>
                  <span className="file-size">{convertBytes(file?.size)}</span>
                </div>
              </div>
            }
          />
          <CustomButton
            title="Save & Upload"
            className={`mr-16 cancel-button ${
              /\S/.test(state.customFileName) &&
              /^[A-Za-z0-9()@ _-]{1,255}$/.test(state.customFileName)
                ? ""
                : "disable-button"
            }`}
            disabled={
              /\S/.test(state.customFileName) &&
              /^[A-Za-z0-9()@ _-]{1,255}$/.test(state.customFileName)
                ? false
                : true
            }
            value={state.customFileName}
            onClick={setCustomeFileName}
          />

          <CustomButton
            htmlType="submit"
            type="primary"
            title="Upload"
            onClick={showConfirmPopup}
            className={state.customFileName !== "" ? "disable-button" : ""}
            disabled={state.customFileName !== "" ? true : false}
          />
        </section>
      </section>
    </div>
  );
};

export default SaveFile;
